import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Hỏi giá (RateInquiryScreen.tsx). Nhãn lọc / trạng thái (inquiry.ts), tên đại lý, nội dung yêu cầu, nhật ký và dữ liệu mẫu không dịch.
addMessages('vi', {
  'ri.sDraft': 'Nháp',
  'ri.sWait': 'Chờ đối tác',
  'ri.sMine': 'Chờ mình',
  'ri.sPriced': 'Có giá',
  'ri.sWon': 'Đã chọn đối tác',
  'ri.sNores': 'Không ai trả lời',
  'ri.lRates': 'Giá cước · bảng giá hãng',
  'ri.lSvc': 'Services Map · tuyến',
  'ri.lP2p': 'Giá và Lịch',
  'ri.open': 'Mở',
  'ri.look': 'Tra',
  'ri.fold': 'Mở hoặc gập {v}',
  'ri.foldTip': 'Mở / gập',
  'ri.draftAi': 'nháp AI',
  'ri.fiReq': 'Thông số gửi cho đối tác từ pricing@hanalogisticsvn.com (CpCode TblMktCampaign INQ-*). · Sale hỏi giá tuyến từ Báo giá · Pricing nhận → có giá (Quoted) hoặc bỏ qua (Skip) · Sale được báo ngay',
  'ri.fiPartners': 'Giá chào là giá mua',
  'ri.fiPartnersNo': 'Không có quyền xem giá mua: chỉ thấy trạng thái trả lời',
  'ri.fiCompare': 'Quy USD theo tỷ giá VCB bán · mốc = giá hãng hiện hành trong Giá cước. Giá chào là giá mua, chỉ hiện khi có quyền xem.',
  'ri.fiActivity': 'Nhật ký yêu cầu · ghi cả vào timeline CRM của đối tác.',
  'ri.fiTodo': 'Việc từ trạng thái trả lời: nhắc đối tác chưa trả lời, xác nhận nháp giá Ask HANA đọc từ mail, chọn đối tác, quét mail trả lời.',
  'ri.fiMain': 'Mã yêu cầu theo CpCode INQ-<dịch vụ>-<ngày>-<số>. Trả lời của đối tác ghi vào CRM.',
  'ri.fiOwners': 'Hai nguồn, gộp và bỏ trùng: (1) theo khách: Sale, CS, Sale Asst, Kế toán ở hồ sơ khách (CUSDATA); (2) nhận xử lý / được giao: người thực hiện trên chính bản ghi theo mô tả công việc (TblOrgJD). Chưa có người hiện Chưa giao; nút Giao chỉ hiện khi có quyền. Hỏi giá: Pricing nhận xử lý cùng Sale yêu cầu. Giá chào chỉ chủ yêu cầu, Pricing và quản lý xem.',
  'ri.fiLinks': 'Mở nhanh các màn liên quan tới yêu cầu này.',
  'ri.aQ': 'Đã chào',
  'ri.aWon': 'Được chọn',
  'ri.aN': 'Không chào',
  'ri.aP': 'Chưa trả lời',
  'ri.noWrite': 'Chưa bật ghi yêu cầu hỏi giá',
  'ri.sentN': '{a} đã gửi · {b} trả lời',
  'ri.notSent': 'chưa gửi',
  'ri.created': '{v} tạo yêu cầu',
  'ri.todoSend': 'Gửi yêu cầu cho đối tác',
  'ri.todoSendSub': 'nháp · chưa gửi từ pricing@',
  'ri.sendMore': 'Gửi thêm',
  'ri.todoRemind': 'Nhắc {n} đối tác chưa trả lời',
  'ri.todoRemindSub': 'gửi nhắc từ pricing@ · ghi nhật ký',
  'ri.remind': 'Nhắc',
  'ri.todoDrafts': 'Xác nhận {n} nháp giá Ask HANA',
  'ri.viewDraft': 'Xem nháp',
  'ri.pickPartner': 'Chọn đối tác',
  'ri.cheapestIs': 'rẻ nhất {v}',
  'ri.pick': 'Chọn',
  'ri.picked': 'Đã chọn đối tác',
  'ri.pickedSub': '{v} · ghi timeline CRM',
  'ri.scanMail': 'Quét mail trả lời',
  'ri.scanSub': 'pricing@ + hộp {v}',
  'ri.scan': 'Quét',
  'ri.iId': 'Mã yêu cầu',
  'ri.iSvc': 'Dịch vụ',
  'ri.iOwner': 'Chủ yêu cầu',
  'ri.iCreated': 'Tạo',
  'ri.iFrom': 'Gửi từ',
  'ri.iReply': 'Trả lời',
  'ri.partnersN': '{a} / {b} đối tác',
  'ri.iStatus': 'Trạng thái',
  'ri.rolePricing': 'Pricing · nhận xử lý',
  'ri.roleSale': 'Sale yêu cầu · được giao',
  'ri.agent': 'Đại lý / đối tác',
  'ri.aiDraftTip': 'Nháp AI · chờ xác nhận',
  'ri.aiDraftAria': 'Nháp AI chờ xác nhận',
  'ri.hInfo': 'Hãng · transit · hiệu lực',
  'ri.hAllin': 'All-in (USD · VCB bán)',
  'ri.actions': 'Thao tác',
  'ri.viewAi': 'Xem nháp AI',
  'ri.savePrice': 'Ghi giá',
  'ri.noQuote': 'Không chào',
  'ri.mail': 'Thư',
  'ri.request': 'Yêu cầu',
  'ri.partners': 'Đối tác nhận yêu cầu',
  'ri.noneSent': 'Chưa gửi cho đối tác nào.',
  'ri.masked': 'Giá chào bị che theo quyền.',
  'ri.compare': 'So sánh giá chào',
  'ri.compareSum': '{n} giá chào · rẻ nhất USD {v}',
  'ri.cheapest': 'rẻ nhất',
  'ri.activity': 'Hoạt động',
  'ri.todo': 'Việc cần làm',
  'ri.todoBadge': '{n} cần làm',
  'ri.ok': 'ổn',
  'ri.todoSum': '{n} việc cần làm',
  'ri.noUrgent': 'Không còn việc gấp',
  'ri.done': 'Xong',
  'ri.needed': 'Cần làm',
  'ri.mainInfo': 'Thông tin chính',
  'ri.owners': 'Người phụ trách',
  'ri.links': 'Liên kết',
  'ri.linksSum': '{n} màn liên quan',
  'ri.list': 'Danh sách yêu cầu',
  'ri.filter': 'Lọc yêu cầu',
  'ri.repliedN': '{a}/{b} trả lời',
  'ri.noneInGroup': 'Không có yêu cầu trong nhóm này.',
  'ri.ticket': 'Phiếu',
  'ri.lane': 'Tuyến (Lane)',
  'ri.carrier': 'Hãng',
  'ri.askedBy': 'Hỏi bởi → Nhận',
  'ri.askedAt': 'Hỏi lúc',
  'ri.result': 'RateCode / lý do',
  'ri.internal': 'Hỏi giá nội bộ',
  'ri.filterTickets': 'Lọc phiếu',
  'ri.internalTickets': 'Phiếu hỏi giá nội bộ',
  'ri.d90': '90 ngày',
  'ri.kRecv': 'Yêu cầu đã nhận',
  'ri.kRecvD': 'cộng mọi đại lý',
  'ri.kRate': 'Tỷ lệ trả lời TB',
  'ri.kRateD': 'trung bình đại lý',
  'ri.recv': 'Nhận',
  'ri.avgReply': 'TG trả lời TB',
  'ri.cheapestCol': 'Rẻ nhất',
  'ri.points': 'Điểm',
  'ri.scoreboard': 'Bảng điểm đại lý',
  'ri.scoreboardH': 'Bảng điểm đại lý / đối tác · 90 ngày',
  'ri.remindN': 'Nhắc {n} đối tác',
  'ri.sendMorePartners': 'Gửi thêm đối tác',
  'ri.back': 'Quay lại danh sách yêu cầu',
  'ri.tasks': 'Việc và thông báo',
  'ri.reqActions': 'Thao tác với yêu cầu',
  'ri.title': 'Hỏi giá',
  'ri.section': 'Mục',
  'ri.tInq': 'Hỏi giá đối tác / đại lý',
  'ri.tScore': 'Chấm điểm agent',
  'ri.more': 'Thao tác khác',
  'ri.viewOpen': 'Xem phiếu đang mở',
  'ri.create': 'Tạo yêu cầu hỏi giá',
  'ri.emptyT': 'Chưa có yêu cầu nào',
  'ri.nopermT': 'Bạn chỉ xem được yêu cầu của mình',
  'ri.errT': 'Không tải được yêu cầu',
  'ri.emptyD': 'Tạo yêu cầu hỏi giá đối tác / đại lý, hoặc chờ Sale gửi phiếu hỏi giá tuyến.',
  'ri.errD': 'Mất kết nối tới máy chủ.',
});
addMessages('en', {
  'ri.sDraft': 'Draft',
  'ri.sWait': 'Waiting for partners',
  'ri.sMine': 'Waiting for me',
  'ri.sPriced': 'Priced',
  'ri.sWon': 'Partner selected',
  'ri.sNores': 'No replies',
  'ri.lRates': 'Freight rates · carrier rate table',
  'ri.lSvc': 'Services Map · lanes',
  'ri.lP2p': 'Rates & Schedules',
  'ri.open': 'Open',
  'ri.look': 'Look up',
  'ri.fold': 'Expand or collapse {v}',
  'ri.foldTip': 'Expand / collapse',
  'ri.draftAi': 'AI draft',
  'ri.fiReq': 'Parameters sent to partners from pricing@hanalogisticsvn.com (CpCode TblMktCampaign INQ-*). · Sale requests a lane rate from Quote · Pricing receives → quoted or skipped · Sale is notified at once',
  'ri.fiPartners': 'Offers are buy rates',
  'ri.fiPartnersNo': 'No permission to view buy rates: only reply status is shown',
  'ri.fiCompare': 'Converted to USD at the VCB sell rate · benchmark = current carrier rate in Rates. Offers are buy rates, shown only with permission.',
  'ri.fiActivity': 'Request log · also written to the partner CRM timeline.',
  'ri.fiTodo': 'Tasks from reply status: remind silent partners, confirm Ask HANA price drafts read from mail, pick a partner, scan reply mail.',
  'ri.fiMain': 'Request code follows CpCode INQ-<service>-<date>-<no>. Partner replies are written to CRM.',
  'ri.fiOwners': 'Two sources, merged and de-duplicated: (1) by customer: Sale, CS, Sale Asst, Accounting on the customer record (CUSDATA); (2) assignee: the person on the record by job description (TblOrgJD). No one shows Unassigned; Assign appears only with permission. Rate inquiry: Pricing handles it with the requesting Sale. Offers visible to the owner, Pricing and managers only.',
  'ri.fiLinks': 'Quick links to screens related to this request.',
  'ri.aQ': 'Quoted',
  'ri.aWon': 'Selected',
  'ri.aN': 'Declined',
  'ri.aP': 'No reply yet',
  'ri.noWrite': 'Writing rate inquiries is not enabled',
  'ri.sentN': '{a} sent · {b} replied',
  'ri.notSent': 'not sent',
  'ri.created': '{v} created the request',
  'ri.todoSend': 'Send the request to partners',
  'ri.todoSendSub': 'draft · not yet sent from pricing@',
  'ri.sendMore': 'Send more',
  'ri.todoRemind': 'Remind {n} partners who have not replied',
  'ri.todoRemindSub': 'reminder sent from pricing@ · logged',
  'ri.remind': 'Remind',
  'ri.todoDrafts': 'Confirm {n} Ask HANA rate drafts',
  'ri.viewDraft': 'View drafts',
  'ri.pickPartner': 'Select a partner',
  'ri.cheapestIs': 'cheapest {v}',
  'ri.pick': 'Select',
  'ri.picked': 'Partner selected',
  'ri.pickedSub': '{v} · written to the CRM timeline',
  'ri.scanMail': 'Scan reply mail',
  'ri.scanSub': 'pricing@ + mailbox of {v}',
  'ri.scan': 'Scan',
  'ri.iId': 'Request ID',
  'ri.iSvc': 'Service',
  'ri.iOwner': 'Requester',
  'ri.iCreated': 'Created',
  'ri.iFrom': 'Sent from',
  'ri.iReply': 'Replies',
  'ri.partnersN': '{a} / {b} partners',
  'ri.iStatus': 'Status',
  'ri.rolePricing': 'Pricing · handling',
  'ri.roleSale': 'Requesting Sales · assigned',
  'ri.agent': 'Agent / partner',
  'ri.aiDraftTip': 'AI draft · awaiting confirmation',
  'ri.aiDraftAria': 'AI draft awaiting confirmation',
  'ri.hInfo': 'Carrier · transit · validity',
  'ri.hAllin': 'All-in (USD · VCB sell)',
  'ri.actions': 'Actions',
  'ri.viewAi': 'View AI draft',
  'ri.savePrice': 'Save rate',
  'ri.noQuote': 'Declined',
  'ri.mail': 'Mail',
  'ri.request': 'Request',
  'ri.partners': 'Partners receiving the request',
  'ri.noneSent': 'Not sent to any partner yet.',
  'ri.masked': 'Quoted rates hidden by permission.',
  'ri.compare': 'Compare quotes',
  'ri.compareSum': '{n} quotes · cheapest USD {v}',
  'ri.cheapest': 'cheapest',
  'ri.activity': 'Activity',
  'ri.todo': 'To do',
  'ri.todoBadge': '{n} to do',
  'ri.ok': 'ok',
  'ri.todoSum': '{n} to do',
  'ri.noUrgent': 'Nothing urgent',
  'ri.done': 'Done',
  'ri.needed': 'To do',
  'ri.mainInfo': 'Main information',
  'ri.owners': 'Owners',
  'ri.links': 'Links',
  'ri.linksSum': '{n} related screens',
  'ri.list': 'Request list',
  'ri.filter': 'Filter requests',
  'ri.repliedN': '{a}/{b} replied',
  'ri.noneInGroup': 'No requests in this group.',
  'ri.ticket': 'Ticket',
  'ri.lane': 'Lane',
  'ri.carrier': 'Carrier',
  'ri.askedBy': 'Asked by → Taken by',
  'ri.askedAt': 'Asked at',
  'ri.result': 'RateCode / reason',
  'ri.internal': 'Internal rate inquiries',
  'ri.filterTickets': 'Filter tickets',
  'ri.internalTickets': 'Internal inquiry tickets',
  'ri.d90': '90 days',
  'ri.kRecv': 'Requests received',
  'ri.kRecvD': 'sum of all agents',
  'ri.kRate': 'Avg reply rate',
  'ri.kRateD': 'agent average',
  'ri.recv': 'Received',
  'ri.avgReply': 'Avg reply time',
  'ri.cheapestCol': 'Cheapest',
  'ri.points': 'Score',
  'ri.scoreboard': 'Agent scoreboard',
  'ri.scoreboardH': 'Agent / partner scoreboard · 90 days',
  'ri.remindN': 'Remind {n} partners',
  'ri.sendMorePartners': 'Send to more partners',
  'ri.back': 'Back to the request list',
  'ri.tasks': 'Tasks and notifications',
  'ri.reqActions': 'Request actions',
  'ri.title': 'Rate inquiries',
  'ri.section': 'Section',
  'ri.tInq': 'Partner / agent inquiries',
  'ri.tScore': 'Agent scoring',
  'ri.more': 'More actions',
  'ri.viewOpen': 'View open tickets',
  'ri.create': 'New rate inquiry',
  'ri.emptyT': 'No requests yet',
  'ri.nopermT': 'You can only see your own requests',
  'ri.errT': 'Could not load requests',
  'ri.emptyD': 'Create a partner / agent rate inquiry, or wait for Sales to send a lane inquiry ticket.',
  'ri.errD': 'Lost connection to the server.',
});
